import BaseClass from "./BaseClass";

class Keys extends BaseClass {
  static get schema() {
    return {
      key: {
        editable: true,
        props: { sortable: true }
      },
      owner: {
        editable: true,
        props: { sortable: true }
      },
      description: {
        editable: true,
        props: { sortable: false }
      },
      created_at: {
        props: { sortable: true }
      },
      updated_at: {
        props: { sortable: true }
      }
    };
  }

  get actions() {
    return {
      edit: {
        handler: () => Promise.resolve(this.uuid),
        props: { type: "info", size: "small" },
        in_edit_mode: false,
        in_submenu: false
      },
      delete: {
        handler: () => this._handleDelete(),
        props: { type: "danger", size: "small" },
        in_edit_mode: false,
        in_submenu: true
      },
      save: {
        handler: () => this._handleSave(),
        props: { type: "success", size: "small" },
        in_edit_mode: true,
        in_submenu: false
      },
      cancel: {
        handler: () => this._handleCancel(),
        props: { type: "default", size: "small" },
        in_edit_mode: true,
        in_submenu: false
      }
    };
  }

  beShownForFilter(filter) {
    return !filter || this.name.toLowerCase().includes(filter.toLowerCase());
  }

  _handleSave() {
    return this._api
      .mutate({
        mutation: require("../../graphql/keys/keys_save.graphql"),
        variables: Object.assign({ trial: !!this.trial }, this)
      })
      .then(res => {
        Object.assign(this, res.data.keys);
        return "saved";
      });
  }

  _handleDelete() {
    return this._confirm("Are you sure want to delete this key?")
      .then(() => {
        return this._api
          .mutate({
            mutation: require("../../graphql/keys/keys_save.graphql"),
            variables: Object.assign({ action: "delete" }, this)
          })
          .then(res => {
            return "deleted";
          });
      })
      .catch(() => {
        return "scipped";
      });
  }

  _handleCancel() {
    if (typeof this.uuid === "undefined") {
      return Promise.reject();
    } else {
      return Promise.resolve("canceled");
    }
  }
}

export default Keys;
